import React, { useContext, useState, useEffect, useCallback, useRef, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'
// eslint-disable-next-line
import { getSearchSuggestions, getSearch } from '../../utils/api'
import { ReactComponent as ArrowbackSVG } from '../../assets/arrow-left.svg'
import { SearchResultMain } from '../SearchResults/SearchResultMain'
import { Loading } from '../helpers/Loading'

const Search = ( { history, location } ) => {
  let params = new URLSearchParams( location.search )
  const [{ searchState }, dispatch] = useContext( GlobalMusicContext )
  const [searchQuery, setSearchQuery] = useState( "" )
  const [suggestions, setSuggestions] = useState( null )
  const [order, setOrder] = useState( [] )
  const [searchOverlay, setOverlay] = useState( false )
  const [ytSearchQuery, setYtSearchQuery] = useState( null )
  const queryRef = useRef( null )
  const [loading, setLoading] = useState( true )
  let songsList = []

  const setSearchState = useCallback( data => {
    dispatch( { type: "setSearchState", snippet: data } )
  },
    [dispatch]
  )
  const setSearchResults = useCallback( data => {
    dispatch( { type: "setSearchResults", snippet: data } )
  },
    [dispatch]
  )

  useEffect( () => {
    queryRef.current.focus()
  }, [] )

  const onSearchSelect = ( result ) => {
    setSearchQuery( result )
    setYtSearchQuery( result )
    setLoading( true )
    history.push( { pathname: "/search", search: `?q=${searchQuery}` } )
    setSearchState( "completed" )
  }

  const searchSuggestion = async () => {
    setLoading( true )
    const response = await getSearchSuggestions( searchQuery, {
      params: { q: searchQuery }
    } )
    if ( searchQuery !== "" ) {
      setSuggestions( response.result )
      setOrder( response?.result?.order )
    } else {
      setSuggestions( null )
    }
    setLoading( false )
  }

  const handleChange = ( e ) => {
    setSearchQuery( e.target.value )
    searchSuggestion()
  }

  const handleSubmit = ( e ) => {
    e.preventDefault()
    setLoading( true )
    e.target.lastChild.blur()
    setYtSearchQuery( searchQuery )
    setLoading( false )
    history.push( { pathname: "/search", search: `?q=${searchQuery}` } )
  }

  useEffect( () => {
    setLoading( true )
    async function getSearchResults( data ) {
      const res = await getSearch( searchQuery, {
        params: {
          q: data,
        }
      } )
      songsList.push( res?.result?.songs )
      setSearchResults( res?.result || [] )
      setLoading( false )
      // return res.result.songs
    }
    if ( ytSearchQuery && ytSearchQuery !== "" ) {
      getSearchResults( ytSearchQuery )
      // setSearchState( "completed" )
    }
    // eslint-disable-next-line
  }, [searchQuery, ytSearchQuery, setSearchResults, setSearchState] )

  useEffect( () => {

  }, [searchState] )

  useEffect( () => {
    const query = params.get( "q" )
    if ( query ) {
      setSearchQuery( query )
      setYtSearchQuery( query )
      setSearchState( "searching" )
    }
    // eslint-disable-next-line
  }, [setSearchState, setYtSearchQuery] )

  const searchResultOverlay = () => {
    switch ( searchState ) {
      case "searching":
        return (
          <Fragment>
            {loading && <Loading />}
          </Fragment>
        )
      case "clicked":
        return (
          <SearchResultMain
            results={suggestions}
            onSearchSelect={onSearchSelect}
            loading={loading}
            order={order}
          />
        )
      case "completed":
        setOverlay( false )
        break
      default:
        break
    }
  }

  return (
    <nav className="search__active">
      {/* autoComplete/search suggest results "overlay" */}
      <div className="search__active nav">
        <ArrowbackSVG className="back__svg"
          onClick={() => {
            setSearchState( "home" )
            if ( history.location.pathname === "/search" ) {
              history.goBack()
            }
          }}
        />
        <form onSubmit={( e ) => handleSubmit( e )} className="search__bar">
          <input
            ref={queryRef}
            type="text"
            placeholder="Search for tracks, artists..."
            name="searchQuery"
            value={searchQuery}
            onChange={handleChange}
            onClick={() => {
              setSearchState( "clicked" )
              setOverlay( true )
            }}
          />
          <div className="nav__svg"></div>
        </form>
      </div>
      <div
        className={`${searchOverlay ? "show" : "hide"}`}
        open={searchOverlay}
        // anchorEl={document.getElementById( "navbar" )}
        id="navbar"
      >
        {searchResultOverlay()}
      </div>
    </nav>
  )
}

export default withRouter( Search )